import { createClient } from '@supabase/supabase-js';
import { fetchConRespaldo } from './sinConexion';

// Credenciales desde .env (REACT_APP_*). El fallback mantiene la app
// funcionando en desarrollo si el .env no está presente.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || 'https://uiurunhsfkjfcchzylet.supabase.co';
const supabaseKey =
  process.env.REACT_APP_SUPABASE_KEY || 'sb_publishable_ad0PytGfHDE2sJ01_58RqA_m4B7v5n5';

// fetchConRespaldo: guarda copia de lo que se lee para verlo sin internet.
export const supabase = createClient(supabaseUrl, supabaseKey, {
  global: { fetch: fetchConRespaldo },
});

// Clave donde Supabase guarda la sesión en este dispositivo.
export const CLAVE_SESION = `sb-${new URL(supabaseUrl).hostname.split('.')[0]}-auth-token`;
